type PlatformLookup = {
  [key: string]: { id: number };
};

const platforms: PlatformLookup = {
  facebook: {
    id: 32,
  },
  instagram: {
    id: 33,
  },
  twitter: {
    id: 34,
  },
};

export default platforms;
